import { useEffect, useState } from 'react';

export function useScroll() {
  const [bodyScrolled, setBodyScrolled] = useState<boolean>(false);
  const [translateHeader, setTranslateHeader] = useState<boolean>(false);
  const [isAtTop, setIsAtTop] = useState<boolean>(true);

  useEffect(() => {
    let lastScrollTop = window.scrollY || document.documentElement.scrollTop;

    const scrollEventFn = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isLargeScreen = window.innerWidth >= 1024;

      setBodyScrolled(scrollTop > 10);
      setIsAtTop(scrollTop <= 0);

      if (isLargeScreen) {
        if (scrollTop > lastScrollTop) {
          setTranslateHeader(true);
        } else {
          setTranslateHeader(false);
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };

    window.addEventListener('scroll', scrollEventFn);
    return () => window.removeEventListener('scroll', scrollEventFn);
  }, []);

  return { bodyScrolled, translateHeader, isAtTop };
}
